import React from "react";
import "./PackageCard.css";
import gradientOverlay from "../../../../assets/images/overlay/gradient-bottom.png";
import { formatDuration } from "../../../../utils/GeneralFunctions";
import { useNavigate } from "react-router-dom";
import testImage from "../../../../assets/images/package-img-default.png";
import staticImage from "../../../../assets/images/package-img-default.png";
import { useTranslation } from "../../../../contexts/TranslationContext";

const PackageCard = ({ item, url }) => {
  const { t } = useTranslation();

  const mainImageItem = item?.gallery?.find((item) => item.main_image === "1");

  let imageUrl = mainImageItem?.image
    ? url + mainImageItem.image
    : item?.gallery.length > 0 ? url + item?.gallery[0]?.image
    : testImage || staticImage;

  // If image path starts with "private", override it with testImage
  if (mainImageItem?.image?.startsWith("/private")) {
    imageUrl = testImage;
  }


  

  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/package/${encodeURIComponent(item.name)}`);
  };

  return (
    <div
      className="PackageCard-container"
      onClick={handleCardClick}
      style={{ cursor: "pointer" }}
    >
      <div
        className="PackageCard-image"
        style={{
          backgroundImage: `url("${imageUrl}")`,
        }}
      >
        {/* Badge for availability */}

        <div className="PackageCard-tags-container">
          {item?.is_block !== 0 && (
            <span className="PackageCard-tag">
              <span>{item?.projected_qty}</span> {t("Available")}  
              {/* /{item?.number_of_tickets} */}
            </span>
          )}

          {/* <span className="PackageCard-tag">
            <span> {t("BestSaller")}</span>
          </span> */}
        </div>

        {/* Gradient image overlay */}
        <div
          className="PackageCard-gradient"
          style={{ backgroundImage: `url(${gradientOverlay})` }}
        />

        {/* Bottom content */}
        <div className="PackageCard-info">
          <div className="PackageCard-info-1">
            <div className="PackageCard-title">
              {item?.name1 || "Trip Title"}
            </div>
            <div className="PackageCard-location">
              {item?.destination_name && (
                <span className="material-icons">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.03875 13.8338C7.03875 13.8338 2.5 10.0113 2.5 6.25C2.5 4.92392 3.02678 3.65215 3.96447 2.71447C4.90215 1.77678 6.17392 1.25 7.5 1.25C8.82608 1.25 10.0979 1.77678 11.0355 2.71447C11.9732 3.65215 12.5 4.92392 12.5 6.25C12.5 10.0113 7.96125 13.8338 7.96125 13.8338C7.70875 14.0663 7.29313 14.0638 7.03875 13.8338ZM7.5 8.4375C7.78727 8.4375 8.07172 8.38092 8.33712 8.27099C8.60252 8.16105 8.84367 7.99992 9.0468 7.7968C9.24992 7.59367 9.41105 7.35252 9.52099 7.08712C9.63092 6.82172 9.6875 6.53727 9.6875 6.25C9.6875 5.96273 9.63092 5.67828 9.52099 5.41288C9.41105 5.14748 9.24992 4.90633 9.0468 4.7032C8.84367 4.50008 8.60252 4.33895 8.33712 4.22901C8.07172 4.11908 7.78727 4.0625 7.5 4.0625C6.91984 4.0625 6.36344 4.29297 5.9532 4.7032C5.54297 5.11344 5.3125 5.66984 5.3125 6.25C5.3125 6.83016 5.54297 7.38656 5.9532 7.7968C6.36344 8.20703 6.91984 8.4375 7.5 8.4375Z"
                      fill="#E8E8E8"
                    />
                  </svg>
                </span>
              )}
              {item?.destination_name && <>{item.destination_name} | </>}
              {formatDuration(item?.duration, t) || "0 Days"}
            </div>
          </div>
          {/* <div className="PackageCard-info-2">
            <div className="PackageCard-price">
              <span className="PackageCard-price-txt">Start From</span>
              <span className="PackageCard-price-value">
                {item?.price || "0"}
                <span className="PackageCard-price-currency">
                  SAR
                </span>
              </span>
            </div>
          </div> */}

          <div className="PackageCard-info-2">
            {parseFloat(item?.price) === 0 ? (
              <button className="PackageCard-quote-button">
                {t("RequestQuote")}
              </button>
            ) : (
              <div className="PackageCard-price">
                <span className="PackageCard-price-txt">{t("StartFrom")}</span>
                <span className="PackageCard-price-value">
                  {item?.price}
                  <span className="PackageCard-price-currency">
                    {item?.currency_symbol || "SAR"}
                  </span>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
